import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
import { TenantRepository } from 'data/service/tenant-repository';
import { autoinject } from 'aurelia-framework';
import { validateCompare } from "../customRules/compareValidation";


@resource('tenant')
@repository(TenantRepository)
@validatedResource()
export class Tenant extends Entity {
	repository: any;

	id: number;
	name = null;
	description = null;
	createdOn: Date;
	
	constructor() {
		super();
		// Todo: localization
		ValidationRules
			.ensure('name').required()
			.ensure('name').maxLength(100)
			.ensure('name').matches(/^[a-zA-Z0-9_\-\s]*$/)
			.ensure('description').required()
			.ensure('description').maxLength(150)
			.on(Tenant);
	}


}